export const productProductFormSchema = {
  type: 'object',
  required: ['quantity', 'productSubassemblyId', 'productAssemblyId'],
  properties: {
    quantity: { type: 'number', exclusiveMinimum: 0 },
  },
};
